// extracted by mini-css-extract-plugin
export default {"root":"switch_root__GrnD8","thumb":"switch_thumb__FMaCK","body":"switch_body__nvMG3"};